import { apiClient } from '../lib/apiClient';

export function search(term, limit) {
  return apiClient.get('/search', { q: term, limit });
}
